import OfficialsLandingScreen from './containers/officialsLandingScreen'

export {default as OfficialsLandingScreenLayout} from './components/officialsLandingScreenLayout'

export default OfficialsLandingScreen
